import { render, staticRenderFns } from "./keyboard-mouse-a45.vue?vue&type=template&id=54552486&"
import script from "./keyboard-mouse-a45.vue?vue&type=script&lang=js&"
export * from "./keyboard-mouse-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports